// 查项目接口
import request from '@/utils/request'

// 获取项目列表
export const getProjectList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectRecord/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 获取项目列表（高级查询）
export const pageTabAdvancedQuery = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectRecord/pageTabAdvancedQuery',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 获取项目详情
export const getProjectDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectRecord/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询项目招投标信息
export const getProjectBiddingPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectBiddingInformation/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询项目招投标信息详情
export const getProjectBiddingDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectBiddingInformation/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询项目施工图审查信息
export const getConstructionDrawingPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/constructionDrawingReview/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询项目施工图审查信息详情
export const getConstructionDrawingDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/constructionDrawingReview/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询合同登记信息
export const getContractRegisterPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/contractRegister/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询合同登记信息详情
export const getContractRegisterDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/contractRegister/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询施工许可
export const getConstructionPermitPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/constructionPermit/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询施工许可详情
export const getConstructionPermitDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/constructionPermit/getDetail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询现场管理人员
export const getProjectManagePersonPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectManagePerson/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询现场管理人员详情
export const getProjectManagePersonDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectManagePerson/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询竣工验收
export const getProjectCompletionPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectCompletion/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询竣工验收详情
export const getProjectCompletionDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectCompletion/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询竣工验收备案
export const getProjectCompletionAcceptancePage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectCompletionAcceptance/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询竣工验收备案详情
export const getProjectCompletionAcceptanceDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectCompletionAcceptance/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 分页查询业绩技术指标
export const getProjectPerformanceIndicatorPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectPerformanceIndicator/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询业绩技术指标详情
export const getProjectPerformanceIndicatorDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectPerformanceIndicator/getDetail',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 资质查-项目报告导出
export const exportProjectReport = params => {
	return process.env.VUE_APP_PREFIX_API_CERTINQUIRE + '/api/projectRecord/exportProjectReport'
}
